var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid text-center mt-5"},[_c('div',{staticClass:"row"},[_c('div',{class:[_vm.currentUser.user_type == 4 ? null : 'col-md-6', 'col-12']},[_c('DashboardSummary')],1),(_vm.currentUser.user_type != 4)?_c('div',{staticClass:"col-12 col-md-6 mt-3 mt-md-0"},[_c('RewardChart')],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }